module.exports = __webpack_public_path__ + "img/color_signature_a-1598-6@2x.0575fe8.jpg";